import React from "react";

const DashboardNavigation = ({
  subscriptionStatus,
  portfolio,
  setShowSubscription,
  setShowHowToStart,
  setShowSettings,
  handleLogout,
}) => {
  return (
    <div className="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-4 sm:space-y-0">
      {/* Left side - Main Navigation Buttons */}
      <div className="grid grid-cols-2 sm:flex sm:flex-wrap items-center gap-2 sm:gap-4 w-full sm:w-auto">
        {/* Subscription Button */}
        <button
          onClick={() => setShowSubscription(true)}
          data-testid="nav-subscription-button"
          className={`px-3 md:px-4 py-3 sm:py-2 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2 text-sm md:text-base min-h-[60px] sm:min-h-0 ${
            subscriptionStatus?.subscribed
              ? 'bg-green-700 hover:bg-green-600'
              : 'bg-yellow-600 hover:bg-yellow-700'
          }`}
          title={subscriptionStatus?.subscribed ? 'Manage Subscription' : 'Subscribe Now'}
        >
          <span className="hidden sm:inline">{subscriptionStatus?.subscribed ? 'Subscription' : 'Subscribe'}</span>
          <span className="sm:hidden font-medium">{subscriptionStatus?.subscribed ? 'Sub' : 'Subscribe'}</span>
          {subscriptionStatus?.subscribed && subscriptionStatus?.days_remaining <= 7 && (
            <span className="bg-red-500 text-xs px-2 py-1 rounded-full">{subscriptionStatus.days_remaining}d</span>
          )}
        </button>

        {/* How to Start Button */}
        <button
          onClick={() => setShowHowToStart(true)}
          data-testid="nav-guide-button"
          className="bg-gray-700 hover:bg-gray-600 px-3 md:px-4 py-3 sm:py-2 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2 text-sm md:text-base min-h-[60px] sm:min-h-0"
          title="How to Start Guide"
        >
          <span className="hidden sm:inline">Guide</span>
          <span className="sm:hidden font-medium">Guide</span>
        </button>

        {/* Settings Button */}
        <button
          onClick={() => setShowSettings(true)}
          data-testid="nav-settings-button"
          className="bg-gray-700 hover:bg-gray-600 px-3 md:px-4 py-3 sm:py-2 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2 text-sm md:text-base min-h-[60px] sm:min-h-0"
          title="Settings"
        >
          <span className="hidden sm:inline">Settings</span>
          <span className="sm:hidden font-medium">Settings</span>
        </button>

        {/* Portfolio Error Warning */}
        {portfolio?.error && !portfolio.error.includes('not configured') && !portfolio.error.includes('No account') && (
          <div className="absolute top-28 right-4 md:right-auto md:left-1/2 md:transform md:-translate-x-1/2 bg-red-600/90 text-white px-4 py-2 rounded-lg shadow-lg z-50">
            {portfolio.error}
          </div>
        )}
      </div>

      {/* Right side - Logout Button (Desktop) */}
      <div className="hidden sm:block">
        <button
          onClick={handleLogout}
          data-testid="nav-logout-button"
          className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded-lg font-semibold transition-colors flex items-center space-x-2 text-sm md:text-base"
          title="Logout"
        >
          <span>Logout</span>
        </button>
      </div>

      {/* Mobile Logout Button */}
      <div className="sm:hidden w-full">
        <button
          onClick={handleLogout}
          data-testid="nav-logout-button-mobile"
          className="bg-red-600 hover:bg-red-700 px-4 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2 text-sm w-full min-h-[60px]"
          title="Logout"
        >
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default DashboardNavigation;
